import { useMemo } from 'react';
import { diffWords } from 'diff';

// Word-level redline between two texts. Insertions carry the editing party's
// color (Word-style "each reviser gets a color"); deletions strike through.
// Pass `tip` (who made this change, and when) to get it on hover over every
// insertion and deletion. Shared by the document view and the audit trail.
export default function Redline({ before, after, insColor, tip }) {
  const parts = useMemo(() => diffWords(before || '', after || ''), [before, after]);
  const ic = insColor || 'var(--ok)';
  const hoverable = tip ? { cursor: 'help' } : undefined;
  return (
    <span style={{ whiteSpace: 'pre-wrap' }}>
      {parts.map((p, i) => {
        if (p.added) {
          return (
            <ins
              key={i}
              style={{ color: ic, textDecoration: 'underline', textDecorationColor: ic, ...hoverable }}
              data-tip={tip ? `Inserted · ${tip}` : undefined}
            >
              {p.value}
            </ins>
          );
        }
        if (p.removed) {
          return (
            <del
              key={i}
              style={{ color: 'var(--danger)', opacity: 0.75, ...hoverable }}
              data-tip={tip ? `Deleted · ${tip}` : undefined}
            >
              {p.value}
            </del>
          );
        }
        return <span key={i}>{p.value}</span>;
      })}
    </span>
  );
}
